import Restaurant from '@components/restaurant/models/Restaurant';
import DesktopWindowsTwoToneIcon from '@mui/icons-material/DesktopWindowsTwoTone';
import MopedTwoToneIcon from '@mui/icons-material/MopedTwoTone';
import ScheduleTwoToneIcon from '@mui/icons-material/ScheduleTwoTone';
import { Box, Chip } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React from 'react';

interface RestaurantBasicInfoProps {
    restaurant: Restaurant;
}

const RestaurantBasicInfo: React.FC<RestaurantBasicInfoProps> = observer(({ restaurant }) => {
    return (
        <Box mt={2} mb={0.5} display={"flex"} color={"#fff"} flexDirection={"row"} flexWrap={"wrap"} gap={{ xs: 1, sm: 2 }}>
            <Chip
                variant='filled'
                color='secondary'
                icon={<DesktopWindowsTwoToneIcon />}
                label={restaurant.isOnline ? 'Na mreži' : 'Izvan mreže'} />


            <Chip
                variant='filled'
                color='secondary'
                icon={<ScheduleTwoToneIcon />}
                label={`${restaurant.openingTime.substr(0, 5)}-${restaurant.closingTime.substr(0, 5)}`} />


            {restaurant.hasDelivery && (
                <>
                <Chip
                    variant='filled'
                    color='secondary'
                    icon={<MopedTwoToneIcon />}
                    label={`${restaurant.deliveryTimeFrom?.substr(0, 5)}-${restaurant.deliveryTimeTo?.substr(0, 5)}`} />
                </>
            )}
        </Box>
    )
})

export default RestaurantBasicInfo;